import type { ReactNode } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { getConfig } from '../lib/config';
import { loadSession, signOut } from '../lib/auth';

export function AppShell({ children }: { children: ReactNode }) {
  const navigate = useNavigate();
  const session = loadSession();

  return (
    <div className="shell">
      <header className="shell-header">
        <Link to="/" className="shell-brand">
          {getConfig().companyName} · AI Interview
        </Link>
        <div className="row">
          {session ? <span className="muted small">{session.email}</span> : null}
          <button
            className="secondary"
            onClick={() => {
              signOut();
              navigate('/login', { replace: true });
            }}
          >
            Sign out
          </button>
        </div>
      </header>
      <main className="shell-main">{children}</main>
    </div>
  );
}
